import * as React from "react";

;
export const ChevronLeft = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.06 12l8.47 8.47-1.06 1.06L5.94 12l9.53-9.53 1.06 1.06L8.06 12z" fill="#100722" /></svg>;